<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="pipas"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Pipas</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="pipanombre"
                          label="Nombre de la pipa"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="mt-n8 mx-auto">
                        <v-text-field
                          v-model="pipacapacidad"
                          label="Capacidad de la Pipa"
                          outlined
                          type="number"
                        ></v-text-field>
                      </v-col>
                     
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="guardar"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

           
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editItem(item)" v-on="on"
                >edit</v-icon
              >
            </template>
            <span>Editar pipa</span>
          </v-tooltip>


          <template v-if="item.pipaestatus == 1">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="desactivar(item)"
                  v-on="on"
                  >toggle_off</v-icon
                >
              </template>
              <span>Desactivar </span>
            </v-tooltip>
          </template>

          <template v-if="item.pipaestatus == 2">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="activar(item)"
                  v-on="on"
                  >toggle_on</v-icon
                >
              </template>
              <span>Activar </span>
            </v-tooltip>
          </template>

          <template>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="eliminar(item)"
                  v-on="on"
                  >delete</v-icon
                >
              </template>
              <span>Eliminar </span>
            </v-tooltip>
          </template>


        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.pipaestatus="{ item }">
          <v-chip
            :color="getColor(item.pipaestatus)"
            dark
            v-if="item.pipaestatus == 1"
            >ACTIVO</v-chip
          >
          <v-chip
            :color="getColor(item.pipaestatus)"
            dark
            v-if="item.pipaestatus == 2"
            >SUSPENDIDO</v-chip
          >
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variables
      pipas: [],
      pipaid:"",
      dialog: false,
      headers: [
        { text: "Operacion", value: "action", sortable: false },
        { text: "Nombre", value: "pipanombre" },
        { text: "Capacidad", value: "pipacapacidad" },
        { text: "Estatus", value: "pipaestatus", sortable: false },
      ],
      search: "",
      pipanombre: "",
      pipacapacidad:"",
      usuarioid: "",
      guardarsino:0,
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      if (this.guardarsino==0){
        return "Nueva pipa";
      }else{
        return "Modificar pipa";
      }
      
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103"; // Verde
      if (socioestatus == 2) return "#DA0707"; // Rojo
    },
    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/pipas/listar", configuracion)
        .then(function (response) {
          me.pipas = response.data.pipa;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Actualiza la categotia
    editItem(item) {
      this.dialog = true;
      this.pipanombre = item.pipanombre;
      this.pipacapacidad=item.pipacapacidad;
      this.pipaid=item.pipaid;
      this.usuarioid = item.usuarioid;
      this.guardarsino=1;
    },

    close() {
      this.reportes = false;
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.pipanombre = "";
      this.pipacapacidad="";
      this.pipaid = "";
      this.guardarsino=0;
    },

    guardar() {
     if (this.pipanombre == "") {
        this.$swal("No se a Especificado Nombre de la Pipa");
        return;
      }

      if (this.pipacapacidad == "") {
        this.$swal("No se a Especificado La Capacidad de la Pipa");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      // Guardar
      if (me.guardarsino == 0) {
        axios
          .post(
            "api/pipas/crear",
            {
              pipanombre: me.pipanombre,
              pipacapacidad: me.pipacapacidad,
              usuarioid: me.$store.state.usuario.usuarioid,
            },
            configuracion
          )
          .then(function(response) {
            me.limpiar();
            me.listar();
            me.TablaVisible = 0;
            me.dialog=false;
            me.$swal("pipa Capturada con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
      // Editar
      if (me.guardarsino == 1) {
        axios
          .put(
            "api/pipas/actualizar/"+me.pipaid,
            {
                pipanombre: me.pipanombre,
                pipacapacidad: me.pipacapacidad,
                usuarioid: me.$store.state.usuario.usuarioid
            },
            configuracion
          )
          .then(function(response) {
            me.TablaVisible = 0;
            me.limpiar();
            me.listar();
            me.dialog=false;
            me.$swal("pipa Actualizada con Exito");
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }

     
    },


   

        desactivar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Desactivar la pipa",
                text:
                    "pipa: " +
                    item.pipanombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Desactivar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/pipas/desactivar",
                            {
                                pipaid: item.pipaid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Desactivado", "Se a Desactivado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },


        activar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Activar la pipa",
                text:
                    "pipa: " +
                    item.pipanombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Activar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/pipas/activar",
                            {
                                pipaid: item.pipaid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Desactivado", "Se a Desactivado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },

        eliminar(item) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header }; // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Eliminar la pipa",
                text:
                    "pipa: " +
                    item.pipanombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Eliminar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/pipas/eliminar",
                            {
                                pipaid: item.pipaid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
        },



    
   
    
  },
};
</script>